import React from 'react';
import { useIntl, useSelector } from 'umi';
import Abnormal from '@/pages/dashboard/components/Abnormal';

import { GameListProps } from '../types';
import GameRow from './GameRow';

const GameList = (props: GameListProps) => {
  const {
    list = [],
    noAccessGameList = [],
    searchValue,
    type,
    setGameModalVisible,
    menuWidth
  } = props;

  const { formatMessage } = useIntl();
  const { followViewList } = useSelector((state: any) => {
    const { followViewList } = state.dashboard;
    return {
      followViewList
    };
  });
  
  return (
    <>
      {
        list?.length > 0 ?
          list?.map((gameInfo: any, index) => (
            <GameRow
              key={index + gameInfo.game_code}
              type={type || 'others'}
              gameInfo={gameInfo}
              followList={followViewList}
              searchValue={searchValue}
              setGameModalVisible={setGameModalVisible}
              menuWidth={menuWidth}
            />
          )) :
          noAccessGameList?.length === 0 ?
            <Abnormal
              style={{ height: 400, marginTop: 90 }}
              isLoading={false}
              isError={false}
              nodataMsg={formatMessage({ id: 'common_search_no_data' })}
              isNoData={list?.length === 0}
            /> : ''
      }
    </>
  );
};

export default GameList;